import { graphql } from '@/gql';

export const UpdatePerformanceBmpResultsMutation = graphql(`
    mutation UpdatePerformanceBmpResults($id: ObjectID!, $input: UpdateBmpResultInput!) {
        updateBmpResult(id: $id, input: $input) {
            ... on UpdateBmpResultSuccessfulResponse {
                result {
                    ...BmpAssessmentResult
                }
            }
            ... on ErrorResponse {
                fields {
                    field
                    message
                }
            }
        }
    }
`);
